const InitializeImageStore = () => {


    const loaders = {};

    return {

        /** 
         * @param id loader name
         * @param assets Array<{id:string, url:string}> 
         * @return promise
         * */
        async fetch(id, assets) {


            if(!id) {
                
                return console.error("Attempted to create undefined loader")
            }

            return new Promise((resolve, reject) => {
                var loader = new Loader({ $emit() { } }, { useWorker: true, decode: false })
                loaders[id] = loader;
                loader.fetch(assets).then(o => {
                    resolve();
                })
            })
        },

        getImage(loaderId, id) {
            return loaders[loaderId].getAsset(id);
        },

        hasLoader(loaderId) {
            return loaders.hasOwnProperty(loaderId);
        },

        all () {
            return loaders;
        }



    }
}